// extracted by mini-css-extract-plugin
export var close = "styles-module--close--4d1a3";
export var form = "styles-module--form--5e413";
export var image = "styles-module--image--1ef6f";
export var imgDesktop = "styles-module--imgDesktop--b8107";
export var imgMobile = "styles-module--imgMobile--fd759";
export var wrapper = "styles-module--wrapper--b5d4f";